<div class="modal-loading text-center" @fadeInOut data-qa="test-loading-modal">
  <div class="modal-loading-box">
    <div class="modal-loading-content">
      <div class="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <p *ngIf="!isCancelVisible && text && text.length">{{ text }}</p>
      <p *ngIf="!isCancelVisible && textSupplierSearchEnabled">
        <span
          *ngFor="let item of suppliers"
          [ngClass]="{ 'fade-in': item === supplierActive, 'fade-out': item !== supplierActive }"
        >
          {{ textSupplierSearch }} {{ item }}...
        </span>
        <span [ngClass]="{ hide: supplierLoopInterval !== false, 'fade-in': !supplierLoopInterval }">
          {{ textSupplierSearchOver }}
        </span>
      </p>
      <p *ngIf="isCancelVisible">{{ textLoadingTimeExceeded }}</p>
      <p *ngIf="isCancelVisible">
        <a href="" click="cancel()">{{ textCancel }}</a>
      </p>
    </div>
  </div>
</div>
